import Loader from '../../../../../../../../common/elements/Loader/Loader';

import './TaskBody.scss';

export default function TaskBody({ isLoading, children }) {
  return <div className="etc-body">{isLoading ? <Loader dark /> : children}</div>;
}
